import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';

export default class CoingateGateway extends PaymentGatewayProcessor {}
